import LoadingAnimation from '../../assets/images/loading.gif'
import { Box, styled } from '@mui/material'

const Container = styled(Box)(({ theme }) => ({
  position: 'absolute',
  zIndex: 20,
  backgroundColor: theme.palette.background.default,
  width: '100%',
  height: '100%',
  display: 'grid',
  placeContent: 'center',
  img: {
    width: '8rem'
  }
}))

export function Loading() {
  return (
    <Container>
      <img alt="loading" src={LoadingAnimation} />
    </Container>
  )
}
